import * as React from 'react';

import { IBuilder, ISeller } from '../../types/newbuildingsCompare';
import { PhoneButton } from '../../components/NewbuildingCallToAction/PhoneButton';
import { useDynamicPhoneCall } from './useDynamicPhoneCall';

export interface ISellerPhoneProps {
  newbuildingId: number;
  url: string;
  target: IBuilder | ISeller;
  isBuilder: boolean;
}

export const SellerPhone: React.FC<ISellerPhoneProps> = ({ newbuildingId, url, target, isBuilder }) => {
  const dial = useDynamicPhoneCall({
    newbuildingId,
    url,
    target,
    sellerType: isBuilder ? 'builders' : 'agents',
  });

  return <PhoneButton onlyIcon onClick={dial} testId="ContactsModalPhoneButton" />;
};
